import { Box, HStack, Header, Pressable, Text } from '@rbilabs/universal-components';

export const Container = Pressable.withConfig({
  flexDir: 'row',
  background: Styles.color.cardBackground,
});

export const StoreCardViewContainer = Box.withConfig({
  flexDir: 'row',
  background: Styles.color.cardBackground,
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  overflow: 'hidden',
  minHeight: '24',
  paddingY: '2',
  paddingX: '3',
  flex: 1,
});

export const StoreCardActionsContainer = HStack.withConfig({
  zIndex: '1',
});

// TODO: RN - implement fadeIn animation
export const FadeIn = Box.withConfig({});

export const PrimaryText = Text.withConfig({
  variant: 'copyTwo',
  color: Styles.color.primary,
});

export const Wrapper = Box.withConfig({
  shadow: 4,
  position: 'relative',
  zIndex: Styles.zIndex.below,
});

export const HalalContainer = Box.withConfig({});

export const Subtitle2 = Header.withConfig({
  variant: 'headerThree',
  mb: '1',
});

export const Body2 = Text.withConfig({
  variant: 'copyTwo',
});
